import { render, staticRenderFns } from "./NotificationBadge.vue?vue&type=template&id=346fcded&scoped=true&"
import script from "./NotificationBadge.vue?vue&type=script&lang=js&"
export * from "./NotificationBadge.vue?vue&type=script&lang=js&"
import style0 from "./NotificationBadge.vue?vue&type=style&index=0&id=346fcded&lang=css&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "346fcded",
  null
  
)

export default component.exports